<template>
  <div class="login-page" :style="{ backgroundImage: `url(${publicPath}login_background.png)` }">
    <!-- Main content -->
    <div class="login-content">
      <!-- Right: login card -->
      <div class="login-right">
        <div class="login-card">
          <h2 class="login-welcome">{{ isLogin ? $t('login.welcome') : $t('login.registerTitle') }}</h2>
          <p class="login-subtitle" v-if="isLogin">
            <span class="login-subtitle-highlight">{{ $t('login.subtitle1') }}</span>{{ $t('login.subtitle2') }}
          </p>

          <form @submit.prevent="handleSubmit" class="login-form">
            <!-- Username (register only) -->
            <div class="form-group" v-if="!isLogin">
              <div class="input-wrapper">
                <img src="/login_email.png" alt="" class="input-icon" />
                <input v-model="form.username" type="text" :placeholder="$t('login.usernamePh')" required />
              </div>
            </div>

            <!-- Email / Username -->
            <div class="form-group">
              <div class="input-wrapper">
                <img src="/login_email.png" alt="" class="input-icon" />
                <input v-if="isLogin" v-model="form.username" type="text" :placeholder="$t('login.usernamePh')" required />
                <input v-else v-model="form.email" type="email" :placeholder="$t('login.emailPh')" required />
              </div>
            </div>

            <!-- Password -->
            <div class="form-group">
              <div class="input-wrapper">
                <img src="/login_password.png" alt="" class="input-icon" />
                <input v-model="form.password" type="password" :placeholder="$t('login.passwordPh')" required />
              </div>
            </div>

            <!-- Confirm Password (register only) -->
            <div class="form-group" v-if="!isLogin">
              <div class="input-wrapper">
                <img src="/login_password.png" alt="" class="input-icon" />
                <input v-model="form.confirmPassword" type="password" :placeholder="$t('login.confirmPasswordPh')" required />
              </div>
            </div>

            <p class="error" v-if="errorMsg">{{ errorMsg }}</p>

            <button type="submit" class="btn-submit" :disabled="loading">
              {{ loading ? $t('login.loading') : (isLogin ? $t('login.submit') : $t('login.submitReg')) }}
            </button>
          </form>

          <p class="switch-text">
            {{ isLogin ? $t('login.noAccount') : $t('login.hasAccount') }}
            <a href="javascript:void(0)" @click="toggleMode">{{ isLogin ? $t('login.goRegister') : $t('login.goLogin') }}</a>
          </p>
        </div>
      </div>
    </div>
    <!-- Toast notification -->
    <transition name="toast-fade">
      <div class="toast-overlay" v-if="toastVisible">
        <div class="toast-box">
          <div class="toast-icon">&#10003;</div>
          <p class="toast-msg">{{ toastMsg }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'LoginPage',
  data() {
    return {
      isLogin: true,
      loading: false,
      errorMsg: '',
      form: { username: '', password: '', email: '', confirmPassword: '' },
      publicPath: process.env.BASE_URL,
      toastVisible: false,
      toastMsg: ''
    }
  },
  methods: {
    toggleMode() {
      this.isLogin = !this.isLogin
      this.errorMsg = ''
    },
    showToast(msg) {
      this.toastMsg = msg
      this.toastVisible = true
      setTimeout(() => { this.toastVisible = false }, 2500)
    },
    async handleSubmit() {
      this.errorMsg = ''

      // trim 处理
      this.form.username = this.form.username.trim()
      this.form.email = this.form.email.trim()

      // 通用校验：用户名和密码不能为空
      if (!this.form.username) {
        this.errorMsg = this.$t('login.required')
        return
      }
      if (!this.form.password) {
        this.errorMsg = this.$t('login.required')
        return
      }

      // 注册额外校验
      if (!this.isLogin) {
        if (this.form.username.length < 3) {
          this.errorMsg = this.$t('login.usernameTooShort')
          return
        }
        if (!/^[a-zA-Z0-9_]+$/.test(this.form.username)) {
          this.errorMsg = this.$t('login.usernameInvalid')
          return
        }
        if (!this.form.email.trim()) {
          this.errorMsg = this.$t('login.required')
          return
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
          this.errorMsg = this.$t('login.emailInvalid')
          return
        }
        if (this.form.password.length < 6) {
          this.errorMsg = this.$t('login.pwdTooShort')
          return
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.errorMsg = this.$t('login.pwdMismatch')
          return
        }
      }
      this.loading = true
      try {
        if (this.isLogin) {
          var res = await api.post('/api/auth/login', { username: this.form.username, password: this.form.password })
          if (res.code === 200) {
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('username', res.data.username)
            this.$router.push('/user/tests')
          } else {
            this.errorMsg = res.message
          }
        } else {
          var regRes = await api.post('/api/auth/register', { username: this.form.username, password: this.form.password, email: this.form.email })
          if (regRes.code === 200) {
            this.isLogin = true
            this.errorMsg = ''
            this.showToast(this.$t('login.registerSuccess'))
          } else {
            this.errorMsg = regRes.message
          }
        }
      } catch (e) {
        this.errorMsg = this.$t('login.networkError')
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}

/* Logo */
.login-logo {
  position: absolute;
  top: 24px;
  left: 36px;
  z-index: 10;
}
.login-logo img {
  height: 36px;
  object-fit: contain;
}

/* Main content layout */
.login-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 100vh;
  padding: 0 8% 0 0;
}

/* Right login card */
.login-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 20px;
  padding: 48px 44px 40px;
  width: 420px;
  box-shadow: 0 8px 40px rgba(43, 125, 233, 0.06), 0 1.5px 6px rgba(0,0,0,0.03);
  border: 1px solid rgba(255, 255, 255, 0.7);
}

/* Welcome heading */
.login-welcome {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin: 0 0 10px;
  letter-spacing: 2px;
}

/* Subtitle */
.login-subtitle {
  text-align: center;
  font-size: 17px;
  color: #1a1a2e;
  margin: 0 0 36px;
  font-weight: 600;
  letter-spacing: 1px;
}
.login-subtitle-highlight {
  color: #2b7de9;
  font-weight: 700;
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-group {
  margin: 0;
}

/* Input wrapper with icon */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-icon {
  position: absolute;
  left: 16px;
  width: 18px;
  height: 18px;
  object-fit: contain;
  opacity: 0.5;
  pointer-events: none;
}
.input-wrapper input {
  width: 100%;
  padding: 14px 16px 14px 46px;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  font-size: 14px;
  color: #333;
  background: rgba(245, 247, 250, 0.7);
  outline: none;
  transition: all 0.25s;
  box-sizing: border-box;
}
.input-wrapper input::placeholder {
  color: #b0b8c4;
  font-size: 14px;
}
.input-wrapper input:focus {
  border-color: #2b7de9;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(43, 125, 233, 0.08);
}

/* Error */
.error {
  color: #ef4444;
  font-size: 13px;
  margin: -4px 0 0;
  text-align: center;
}

/* Submit button */
.btn-submit {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #2b7de9 0%, #1a6ad4 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s;
  letter-spacing: 4px;
  margin-top: 4px;
}
.btn-submit:hover {
  background: linear-gradient(135deg, #1a6ad4 0%, #1558b8 100%);
  box-shadow: 0 4px 16px rgba(43, 125, 233, 0.25);
  transform: translateY(-1px);
}
.btn-submit:active {
  transform: translateY(0);
}
.btn-submit:disabled {
  background: linear-gradient(135deg, #93bff0 0%, #a8ccf4 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Switch text */
.switch-text {
  text-align: center;
  margin-top: 24px;
  font-size: 13px;
  color: #888;
}
.switch-text a {
  color: #2b7de9;
  text-decoration: none;
  font-weight: 600;
  margin-left: 4px;
}
.switch-text a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 960px) {
  .login-content {
    justify-content: center;
    padding: 80px 20px 40px;
  }
  .login-card {
    width: 100%;
    max-width: 420px;
    padding: 36px 28px 32px;
  }
}
@media (max-width: 480px) {
  .login-card {
    padding: 28px 20px 24px;
    border-radius: 16px;
  }
  .login-welcome {
    font-size: 22px;
  }
  .login-subtitle {
    font-size: 15px;
  }
}

/* Toast */
.toast-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.toast-box {
  background: #fff;
  border-radius: 16px;
  padding: 36px 48px;
  text-align: center;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}
.toast-icon {
  width: 52px; height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2b7de9, #1a6ad4);
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}
.toast-msg {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.6;
}

/* Toast transition */
.toast-fade-enter-active, .toast-fade-leave-active {
  transition: opacity 0.3s ease;
}
.toast-fade-enter, .toast-fade-leave-to {
  opacity: 0;
}
</style>
